import { UserFormType } from './UserFormType';

export const createUserFormInitialValues = (): UserFormType => ({
  email: '',
  name: '',
  password: '',
  roles: []
});
